import styled, { css, StyledComponent } from '@xstyled/styled-components'
import { variant, breakpoints } from '@xstyled/system'
import proportion from '@/modules/utils/proportion'

const varActive = variant({
  default: 'light',
  prop: 'variant',
  variants: {
    dark: css`
      color: #444;
    `,
    darkSelected: css`
      border-bottom-color: decoration;
      border-bottom-style: solid;
      border-bottom-width: 1px;
      color: #fff;
    `,
    light: css`
      color: #ccc;
    `,
    lightSelected: css`
      border-bottom-color: decoration;
      border-bottom-style: solid;
      border-bottom-width: 1px;
      color: #000;
    `,
  },
})

export const Container = styled.div`
  display: flex;
  /* overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none; */
  overflow: hidden;

  ::-webkit-scrollbar {
    height: 0;
    width: 0;
  }
`

export const Day: StyledComponent<
  'div',
  Record<string, unknown>,
  { variant: string },
  never
> = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  margin: 0 25px 0 0;
  padding-bottom: 10px;
  transition: color 0.2s linear;
  ${varActive}
`

export const DayName = styled.div`
  font-size: 11px;
  margin-bottom: 10px;
  font-weight: bold;
  text-transform: uppercase;
  margin-top: 20px;
`

export const DayNumber = styled.div`
  font-family: title;
  user-select: none;
  /* font-size: ${proportion(66, 'handheld')}; */
  font-size: 66px;
  ${breakpoints({
    md: css`
      font-size: ${proportion(66, 'desktop')};
    `,
    xl: css`
      font-size: 66px;
    `,
  })}
  font-weight: bold;
  line-height: 44px;
  position: relative;
  text-transform: uppercase;
`
